import React from 'react';
import { Link } from 'react-router-dom';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { observer } from 'mobx-react';
import img from "../../../../public/static/img/logo-white.png"
import checkoutImg from '../../img/check-out.png';
import { Validate } from '../../config.js';
// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import * as icons from '../Icons/Icons';
import Help from '../Help/Help';

const Header = observer(class Header extends React.Component {
  constructor(props) {
    super();
    
    this.state = {
      navOpen: false,
      activePage: '',
      firstRender: true,
      showHybrid: false,
      showHybridCheckout: false
    }

    // Bind this to functions
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.renderPoliciesButton = this.renderPoliciesButton.bind(this);
  }

  componentWillMount() {
    const { SessionStore, HybridStore } = this.props.store
    SessionStore.getUnreadCount();
    if (SessionStore.account && SessionStore.account.enableHybridCheckout) {
      HybridStore.listCheckoutSessions(1);
      setInterval(() => HybridStore.listCheckoutSessions(1), 60000);
    }
  }

  handleLinkClick() {
    const dropdowns = [];
    dropdowns.push(this.refs.pagesDropdown);
    dropdowns.push(this.refs.accountDropdown);
    for(var i = 0; i < dropdowns.length; i++) {
      if(typeof dropdowns[i] !== 'undefined') {
        dropdowns[i].hide();
      }
    }
    this.setState({
      navOpen: false
    });
  }

  toggleNav(e) {
    e.preventDefault();
    this.setState({
      navOpen: !this.state.navOpen
    });
  }

  isActive(url) {
    if(url === this.props.routing.location.pathname) {
      return true;
    } else {
      return false;
    }
  }

  renderPoliciesButton() {
    const { translation } = this.props;

    return (
      <li>
        <Link
          className={`navbar__item ${this.isActive('policies') ? 'navbar__item--active' : ''}`}
          to="/policies"
          onClick={this.handleLinkClick}
        >
          <icons.iconClipboard />
          {translation.navigation.policies}
        </Link>
      </li>
    )
  }

  renderHybrid = () => {
    if (!this.state.firstRender) return null;

    this.setState({ firstRender: false })
    const { SessionStore } = this.props.store;

    this.setState({ showHybrid: true });

    try {
      if (SessionStore.account.enableHybridCheckout) {
        this.setState({ showHybridCheckout: true});
      }
    } catch (error) {
      // no op
    }
    return null;
  }

  render() {
    let openClass = null;
    let menuText = 'Menu';

    if(this.state.navOpen) {
      openClass = 'open';
      menuText = 'Close';
    } else {
      menuText = 'Menu';
    }

    const { translation, store } = this.props;
    const { SessionStore, HybridStore } = store;
    const {  checkoutSessionCount } = HybridStore;
    const { userData } = SessionStore;
    const { proctorAccountSid } = userData;
    const { showHybrid, showHybridCheckout } = this.state;

    return(
      <Validate>
      <header className="site-head wrap">
          {!this.props.hideNav &&
            <a href="'/'" className={`nav-btn ${openClass}`} onClick={this.toggleNav}><span className="meta">{menuText}</span></a>
          }

          <h1 className="meta">SmarterProctoring</h1>

          {!this.props.hideNav &&
            <Link className="branding" to="/">
              <img src={img} width="191" alt="SmarterProctoring" />
            </Link>
          }

          {this.props.hideNav &&
            <span className="branding">
              <img src={img} width="191" alt="SmarterProctoring" />
            </span>
          }

          {this.props.hideNav &&
            <ul className="account-menu dropdown">
              <li>
                <Help
                  btnClass="account-menu__item"
                  {...this.props}
                />
              </li>
            </ul>
          }

          {userData && !this.props.hideNav &&
            <ul className="account-menu dropdown" aria-haspopup="true">
              <li>
                <Dropdown ref="accountDropdown">
                  <DropdownTrigger className="dropdown__trigger" aria-controls="#nav-account">
                    <icons.iconGear />
                  </DropdownTrigger>

                  <DropdownContent>
                    <ul id="nav-pages" className="dropdown__menu" role="menu" aria-hidden="true">
                      <li iamAction='sp:DescribeBalance' iamResource={`ssrn:ss:sp::${proctorAccountSid}:balance`}>
                        <Link className="dropdown__item" to="/settings" onClick={this.handleLinkClick}>{translation.navigation.account.settings}</Link>
                      </li>
                      <li className="dropdown__separated">
                        <a className="dropdown__item" href="#" onClick={() => {SessionStore.logout(this.props.routing.history)}}>{translation.navigation.account.sign_out}</a>
                      </li>
                    </ul>
                  </DropdownContent>
                </Dropdown>
              </li>
              <li className="separator">
                <Help
                  btnClass="account-menu__item"
                  {...this.props}
                />
              </li>
            </ul>
          }

          {/* This doesn't render anything anymore. It just updates state*/}
          <FeatureFlag
              flagKey="hybrid"
              renderFeatureCallback={this.renderHybrid}
          />

          {!this.props.hideNav &&
            <nav id="nav" className={`navbar ${openClass}`} role="menubar">
              <h2 className="meta">{translation.navigation.heading}</h2>

              <ul className="navbar__menu">
                <li iamAction='sp:DescribeBalance' iamResource={`ssrn:ss:sp::${proctorAccountSid}:balance`}>
                  <Link className={`navbar__item ${this.isActive('/') ? 'navbar__item--active' : ''}`} to="/" onClick={this.handleLinkClick}>
                    <icons.iconDashboard />
                    {translation.navigation.dashboard}
                  </Link>
                </li>
                <li iamAction="sp:CreateMessageThread" iamResource={`ssrn:ss:sp::${proctorAccountSid}:message`}>
                  <Link className={`navbar__item notification-anchor ${this.isActive('/messages') ? 'navbar__item--active' : ''}`} to="/messages" onClick={this.handleLinkClick}>
                    <icons.iconEnvelope />
                    {translation.navigation.messages}

                    {SessionStore.unreadCount > 0 &&
                      <span className="notification__count badge">{SessionStore.unreadCount}</span>
                    }
                  </Link>
                </li>
                <li iamAction="sp:DescribeExamSessions" iamResource={`ssrn:ss:sp::${proctorAccountSid}:session`}>
                  <Link
                    className={`
                      navbar__item
                      ${this.isActive('/sessions') ? 'navbar__item--active' : ''}
                      ${this.isActive('/pending-sessions') ? 'navbar__item--active' : ''}
                    `}
                    to="/sessions"
                    onClick={this.handleLinkClick}
                  >
                    <icons.iconClock />
                    {translation.navigation.sessions}
                  </Link>
                </li>
                <li iamAction="sp:CreateProctorAccountLocationAvailability" iamResource={`ssrn:ss:sp::${proctorAccountSid}:location`}>
                  <Link className={`navbar__item ${this.isActive('/locations') ? 'navbar__item--active' : ''}`} to="/locations" onClick={this.handleLinkClick}>
                    <icons.iconMapMarker />
                    {translation.navigation.locations}
                  </Link>
                </li>
                {/* The route this leads to doesn't exist? Maybe work that was half done and forgotten about
                {SessionStore.userData.isSuperAdmin && SessionStore.smarterscheduling &&
                  <li>
                    <Link className={`navbar__item ${this.isActive('/calendars') ? 'navbar__item--active' : ''}`} to="/calendars" onClick={this.handleLinkClick}>
                      <icons.iconCalendar />
                      {translation.navigation.calendars}
                    </Link>
                  </li>
                } */}
                <li iamAction='sp:DescribeBalance' iamResource={`ssrn:ss:sp::${proctorAccountSid}:balance`}>
                  <Link className={`navbar__item ${this.isActive('/payments') ? 'navbar__item--active' : ''}`} to="/payments" onClick={this.handleLinkClick}>
                    <icons.iconUSD />
                    {translation.navigation.payments}
                  </Link>
                </li>
                <FeatureFlag
                  flagKey="proctor-cancellation-policies"
                  renderFeatureCallback={this.renderPoliciesButton}
                />
                <li iamAction={['sp:DescribeExamSessions', 'sp:DescribeAppointmentTimeline', 'sp:DescribeExamList']} iamResource={`ssrn:ss:sp::${proctorAccountSid}:*`}>
                  <Link className={`navbar__item ${this.isActive('/reports') ? 'navbar__item--active' : ''}`} to="/reports" onClick={this.handleLinkClick}>
                    <icons.iconGraph />
                    {translation.navigation.reports}
                  </Link>
                </li>
                {SessionStore.userData.isSuperAdmin &&
                <li>
                  <Link className={`navbar__item ${this.isActive('/users') ? 'navbar__item--active' : ''}`} to="/users" onClick={this.handleLinkClick}>
                    <icons.iconPerson />
                    {translation.navigation.users}
                  </Link>
                </li>
                }
                {showHybrid && 
                  <Validate>
                    <li iamAction="sp:DescribeHybridRooms" iamResource={`ssrn:ss:sp::${proctorAccountSid}:hybridRoom`}>
                      <Link
                          className={`navbar__item ${this.isActive('/hybrid-proctoring') ? 'navbar__item--active' : ''}`}
                          to="/hybrid-proctoring"
                          onClick={this.handleLinkClick}
                      >
                        <icons.iconEye />
                        {translation.navigation.hybrid_proctoring}
                      </Link>
                    </li>
                  </Validate>
                }

                {showHybrid && showHybridCheckout &&
                  <Validate>
                    <li iamAction="sp:DescribeCheckoutQueue" iamResource={`ssrn:ss:sp::${proctorAccountSid}:checkoutQueue`}>
                      <Link
                        className={`navbar__item notification-anchor ${this.isActive('/checkout') ? 'navbar__item--active' : ''}`}
                        to="/checkout"
                      >
                        <img src={checkoutImg} className='icn' alt='Checkout queue'/>
                        {translation.navigation.checkout_queue}

                        {checkoutSessionCount > 0 &&
                          <span className="notification__count badge">{checkoutSessionCount}</span>
                        }
                      </Link>
                    </li>
                  </Validate>
                }
              </ul>
            </nav>
          }
      </header>
      </Validate>
    );
  }
})

export default translate('Header')(Header);



// WEBPACK FOOTER //
// ./src/app/components/Common/Header.js